import {
    IonCol,
    IonContent,
    IonPage,
    IonRow,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import Header from "../../../../components/Headers/Header";
import PageTitle from "../../../../components/PageTitle/PageTitle";
import { RouteComponentProps, useHistory } from "react-router";
import { Barn } from "../../../../models";
import { getBarnById } from "../../../../utilities/barn/Barn";
import ErrorAlert from "../../../../components/Errors/ErrorAlert";
import EditPeopleTable from "../../../../components/Rider/EditPeopleTable";
import { BarnPerson } from "../../../../interfaces/Person";


interface BarnPageProps extends RouteComponentProps<{
    id: string;
}> {}

const BarnPeoplePage: React.FC<BarnPageProps> = ({match}) => {
    const history = useHistory();

    const [previousBarn, setPreviousBarn] = useState<Barn | null>(null);
    const [barn, setBarn] = useState<Barn>();
    const [error, setError] = useState("");

    useEffect(() => {
        async function getBarn() {
            const queryResult = await getBarnById(match.params.id);
            if (queryResult.isSuccess) {
                setBarn(queryResult.result);
                setPreviousBarn(queryResult.result);
            } else {
                setError("Sorry, a problem occurred. Please go back and try again.");
            }
        }

        if (!barn || match.params.id !== previousBarn?.id) {
            getBarn();
        }
    }, [match]);
    
    const handleSelectPerson = (person: BarnPerson) => {
        // To navigate to the edit person page, we need to know the type of person and the id of the person.
        // path = "/index/staff/barn/" + {barn.id} + "/person/" + "/" + {type} + "/" + {type.id};
        if (barn) {
            let path = "/index/staff/barn/" + barn.id + "/person/";
            let endOfPath: string | null = null;

            // Check for a role, and try to use the role to navigate to the edit person page.
            if (person.fullRoles) {
                person.fullRoles.forEach(role => {
                    if (endOfPath === null) {
                        if (role.role === "rider") {
                            endOfPath = "rider/" + role.rider?.id;
                        }
                        else if (role.role === "owner") {
                            endOfPath = "owner/" + role.owner?.id;
                        }
                        else if (role.role === "trainer") {
                            endOfPath = "trainer/" + role.trainer?.id;
                        }
                    }
                });
            } 
            // If no role is found, use the personId to navigate to the edit person page.
            else if (person.personId) {
                endOfPath = "member/" + person.personId;
            }

            if (endOfPath) {
                const fullPath = path + endOfPath;
                history.push(fullPath);
            } else {
                setError("Could not go to the edit person page.");
            }
        } else {
            setError("Could not go to the edit person page.");
        }
    }   

    return (
        <IonPage className="bg-light">
            <Header />
            <IonContent>
                <PageTitle title={barn ? barn.name : "People"} />
                {error && <ErrorAlert width="12" error={error} />}
                <IonRow className="ion-justify-content-center">
                    <IonCol size="12">
                        <EditPeopleTable barn={barn} onSelect={(barnPerson: BarnPerson) => handleSelectPerson(barnPerson)} />
                    </IonCol>
                </IonRow>
            </IonContent>
        </IonPage>
    );
};

export default BarnPeoplePage;